// extracted by mini-css-extract-plugin
export default {"portfolioContainer":"portfolioContainer_Cxfw","portfolio":"portfolio_ZpGQ","projects":"projects_PQXg","loadMoreButton":"loadMoreButton_aBu4"};